import React, { useEffect } from "react";
import GridItem from "../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import ProfileImageComponent from "./ProfileImageComponent/ProfileImageComponent";
import PersonalDetails from "./PersonalDetails/PersonalDetails";
import { AuthDetailsConfig } from "./PersonalDetails/PersonalDetailsConfig";
import { useSelector } from "react-redux";
import DMSHeader from "../../Pages/DMS/DMSHeader/DMSHeader";
import DetailsHandler from "../DMS/Common/DetailsHandler/DetailsHandler";
import { useTranslation } from 'react-i18next';
import FleetProfile from "./FleetProfile/FleetProfile";

export default function UserProfile() {
  const { t } = useTranslation();
  const { profileData } = useSelector((store) => store.data);
  // Read straight from the store so the first render already knows bank vs fleet
  const userData = profileData;
  useEffect(() => {
    GridStack.init();
  }, [profileData]);

  const profile = userData && userData[0];
  const isFleetUser = String(profile?.app_type || "").toUpperCase() === "FLEET";

  const header = {
    x: 0,
    y: 0,
    width: 12,
    height: 1,
    id: 1,
    component: <DMSHeader title={t('user_profile')} showIconsForback={true} />,
    haveOverflowVisible: true,
  };

  // Fleet users get the fleet profile (employee, license, emergency contact, module access…)
  const fleetLayoutData = [
    header,
    {
      x: 0,
      y: 1,
      width: 12,
      height: 13,
      id: 2,
      component: <FleetProfile profile={profile} />,
    },
  ];

  const layoutData = isFleetUser ? fleetLayoutData : [
    header,
    {
      x: 0,
      y: 1,
      width: 4,
      height: 10, // = Authorized (4) + Personal (6), so both sides end together
      id: 2,
      component: <ProfileImageComponent profileData={userData && userData[0]} />,
    },
    {
      x: 4,
      y: 1,
      width: 8,
      height: 4, // 3 was a little short for the title + User Name → scrollbar
      id: 2,
      component: (
        <DetailsHandler
          title={t('authorized_detail')}
          details={userData && userData[0]}
          columns={2}
          config={AuthDetailsConfig()}
        />
      ),
    },
    {
      x: 4,
      y: 5,
      width: 8,
      height: 6,
      id: 2,
      component: <PersonalDetails userData={userData && userData[0]} />,
    },
  ];
  // Wait for the profile so the grid is laid out once with the right (bank or fleet) layout
  if (!profile) return null;

  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem key={isFleetUser ? "fleet" : "bank"} layoutData={layoutData} />
    </div>
  );
}
